import basicArrow from './src/BasicArrow.vue'
import basicHelp from './src/BasicHelp.vue'
import basicTitle from './src/BasicTitle.vue'

import { withInstall } from '@/utils'

export const BasicArrow = withInstall(basicArrow)
export const BasicHelp = withInstall(basicHelp)
export const BasicTitle = withInstall(basicTitle)
